import api from "../../../lib/axios";
import type { BaseResponse } from "../../../lib/api-contract";
import type { RewardHistoryAPIItem } from "../types/RewardHistory";

export interface RewardHistoryListRequest {
  filter?: {
    user_name?: string;
    user_email?: string;
    reward_name?: string;
    redemption_status?: "redeemed" | "used" | "pending" | "failed";
    date_from?: string;
    date_to?: string;
  };
  pagination: { index: number; size: number };
}

export interface RewardHistoryListResponse {
  data: RewardHistoryAPIItem[];
  pagination: { count: number; index: number; size: number };
}

export interface RewardHistoryStatistic {
  total_sent_rewards: number;
  total_redeemed_rewards: number;
}

export interface ResendRewardResponse {
  resend_count: number;
  resend_date: string;
}

export async function getRewardHistoryList(
  request: RewardHistoryListRequest,
): Promise<RewardHistoryListResponse> {
  const response = await api.post<BaseResponse<RewardHistoryListResponse>>(
    "/v1/portal/reward-history",
    request,
  );
  if (!response.data.success || !response.data.data)
    throw new Error(response.data.user_message || "Failed to load reward history");
  return response.data.data;
}

export async function getRewardHistoryStatistic(): Promise<RewardHistoryStatistic> {
  const response = await api.post<BaseResponse<RewardHistoryStatistic>>(
    "/v1/portal/reward-history/statistic",
  );
  if (!response.data.success || !response.data.data)
    throw new Error(response.data.user_message || "Failed to load reward history statistics");
  return response.data.data;
}

export async function resendReward(userCouponId: string): Promise<ResendRewardResponse> {
  const response = await api.post<BaseResponse<ResendRewardResponse>>(
    `/v1/portal/reward-history/resend/${userCouponId}`,
  );
  if (!response.data.success || !response.data.data)
    throw new Error(response.data.user_message || "Failed to resend reward");
  return response.data.data;
}
